export const SetEntornoEmp = (em:any) =>{
    return {type:"SetEntornoEmp", emp: em};
};

export const GetEntornoEmp = () =>{
    return {type:"GetEntornoEmp"};
};

